import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { xxllncColor } from '../../layout/themes'

export const PREFIX = 'xxllncActionForm'

export const classes = {
  card: `${PREFIX}-card`,
  statusToggle: `${PREFIX}-statusToggle`,
  statusButton: `${PREFIX}-statusButton`,
  statusButtonActive: `${PREFIX}-statusButtonActive`,
  actionButton: `${PREFIX}-actionButton`,
  medewerkerDropdown: `${PREFIX}-medewerkerDropdown`,
  questionTab: `${PREFIX}-questionTab`,
  questionTabActive: `${PREFIX}-questionTabActive`,
}

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),

  [`& .${classes.card}`]: {
    padding: theme.spacing(3),
    borderRadius: '16px',
    border: `1px solid ${xxllncColor.alto}`,
    boxShadow: 'none',
  },

  [`& .${classes.statusToggle}`]: {
    display: 'flex',
    backgroundColor: xxllncColor.alto,
    borderRadius: '20px',
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.statusButton}`]: {
    'borderRadius': '15px',
    'textTransform': 'none',
    'fontWeight': 'bold',
    'backgroundColor': 'transparent',
    'color': 'black',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.25)' },
  },

  [`& .${classes.statusButtonActive}`]: {
    'backgroundColor': 'black',
    'color': '#fff',
    '&:hover': { backgroundColor: 'black' },
  },

  [`& .${classes.actionButton}`]: {
    flex: 1,
    borderRadius: '20px',
    textTransform: 'none',
  },

  [`& .${classes.medewerkerDropdown}`]: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 10,
    marginTop: theme.spacing(0.5),
    maxHeight: 200,
    overflow: 'auto',
    border: `1px solid ${xxllncColor.alto}`,
  },

  [`& .${classes.questionTab}`]: {
    'minWidth': 32,
    'width': 32,
    'height': 32,
    'borderRadius': '50%',
    'border': `2px solid ${xxllncColor.veniceBlue}`,
    'backgroundColor': 'transparent',
    'color': xxllncColor.veniceBlue,
    'fontWeight': 'bold',
    'fontSize': '0.85rem',
    'cursor': 'pointer',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'padding': 0,
    '&:hover': { backgroundColor: xxllncColor.veniceBlue, color: '#fff' },
  },

  [`& .${classes.questionTabActive}`]: {
    backgroundColor: xxllncColor.veniceBlue,
    color: '#fff',
  },
}))